// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2_ecS","content":"GlobalSearch_content__qJ_VG"};